import React from "react";
import classNames from "classnames/bind";

import { ScreenInfo } from "../../components/ScreenInfo";
import { Button } from "../../components/Button";
import { WelcomeCarousel } from "../../components/WelcomeCarousel";
import { DietanamnezType } from "../../types/DietanamnezType";

import styles from "./RegistrationSuccess.module.css";
import { useStateManager } from "utils/useStateManager";

const cx = classNames.bind(styles);

type Props = {
  onSubmit: (exists?: boolean) => void;
};

export const RegistrationSuccess: React.FC<Props> = ({ onSubmit }) => {
  const { linkInfo, userType, updateDietanamnez } = useStateManager();
  const initialDietanamnezType = linkInfo?.survey_type;

  const handleSubmit = (type: DietanamnezType) => {
    updateDietanamnez({
      custom_тип_да: type,
    });

    onSubmit();
  };

  return (
    <ScreenInfo>
      <div>
        {initialDietanamnezType ? (
          <WelcomeCarousel
            userType={userType}
            dietanamnezType={initialDietanamnezType}
            carouselType="FINISH_REGISTRY"
          />
        ) : (
          <p className={cx("info")}>
            Выберите удобный вам формат
            опроса по фактическому питанию:
          </p>
        )}
        {initialDietanamnezType ? (
          <div className={cx("actions")}>
            <Button
              color="white"
              block
              size="medium"
              rounded
              type="button"
              onClick={() => handleSubmit(initialDietanamnezType)}
            >
              Продолжить
            </Button>
          </div>
        ) : (
          <div className={cx("actions")}>
            <button
              type="button"
              className={cx("typeButton")}
              onClick={() => handleSubmit(2)}
            >
              <p className={cx("typeTitle")}>Я отвечу подробно</p>
              <p className={cx("typeLabel")}>
                Выбор тех, кто хочет максимальной точности анализа. Мы спросим вас
                о 100 продуктах в 13 группах. Это займет от 20 минут времени.
              </p>
            </button>
            <button
              type="button"
              className={cx("typeButton")}
              onClick={() => handleSubmit(1)}
            >
              <p className={cx("typeTitle")}>Я отвечу кратко</p>
              <p className={cx("typeLabel")}>
                Быстрый, компромиссный вариант, но все еще информативный. Мы
                спросим вас о 36 продуктах в 7 группах. Это займет от 10 минут
                времени.
              </p>
            </button>
          </div>
        )}
      </div>
    </ScreenInfo>
  );
};
